import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestTripDetail } from 'src/app/interfaces/RequestTripDetail';
import { IDetailTripResponse } from 'src/app/interfaces/Responses/IDetailTripResponse';
import { IRealTimeDashboardResponse } from 'src/app/interfaces/Responses/IRealTimeDashboardResponse';
import { ITrucksByCheckpointResponse } from 'src/app/interfaces/Responses/ITrucksByCheckpointResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RealTimeService {

  url: string = environment.urlBaseService
  urlDetailTrip = `${this.url}RealTimesTrucktDetail`
  urlTrucksByCheckpoint = `${this.url}RealTimeTrucksByCheckpoint`
  urlRealTimeDashboard = `${this.url}RealTimeDashboard`
  urlRealTimeDashboardByPlate = `${this.url}RealTimeDashboardByPlate`
  urlSourceDevicesStatus = `${this.url}SourceDevicesStatus`
  urlTripdetail = `${this.url}RealTimesTrucktDetail/tripdetail`

  constructor(private httpClient: HttpClient) {
  }

  getRealTimeDashboard(siteID: string, dashboardID: string): Observable<IRealTimeDashboardResponse> {
    return this.httpClient.get<IRealTimeDashboardResponse>(`${this.urlRealTimeDashboard}?SITE_ID=${siteID}&DASHBOARD_CONFIG_ID=${dashboardID}`)
  }

  getDetailTrip(tripId: string, type: string, hasLocalStorage: boolean): Observable<IDetailTripResponse> {
    const site = localStorage.getItem('site')
    return this.httpClient.get<IDetailTripResponse>(`${this.urlDetailTrip}?TRIP_ID=${tripId}&DASHBOARD_CONFIG_ID=${type}&site=${site}&hasLocalStorage=${hasLocalStorage}`)
  }

  getTrucksByCheckpoint(checkPointID: string, siteID: string, dashboardID: string): Observable<ITrucksByCheckpointResponse> {
    return this.httpClient.get<ITrucksByCheckpointResponse>(`${this.urlTrucksByCheckpoint}?CHECKPOINT_ID=${checkPointID}&SITE_ID=${siteID}&DASHBOARDCONF_ID=${dashboardID}`)
  }

  getRealTimeDashboardByPlate(siteId: string, plate: string, dashboardID: string): Observable<IRealTimeDashboardResponse> {
    const site = localStorage.getItem('site')
    return this.httpClient.get<IRealTimeDashboardResponse>(`${this.urlRealTimeDashboardByPlate}?SITE_ID=${siteId}&PLATE_NUMBER=${plate}&DASHBOARDCONF_ID=${dashboardID}&site=${site}`)
  }

  getSourceDevicesStatus(siteId: string): Observable<any> {
    const site = localStorage.getItem('site')
    return this.httpClient.get<any>(`${this.urlSourceDevicesStatus}?SITE_ID=${siteId}&site=${site}`)
  }

  UpdateTripDetail(requestTripDetail: RequestTripDetail): Observable<any> {
    return this.httpClient.put<any>(`${this.urlTripdetail}`, requestTripDetail)
  }
}
